const Calendar = () => {
    
    return (
        <div className="calendar">
            <h1>THIS IS THE CALENDAR PAGE</h1>

        </div>
    )
}

export default Calendar